(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1465],{

/***/ 88572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "boundClass": function() { return /* binding */ boundClass; },
/* harmony export */   "boundMethod": function() { return /* binding */ boundMethod; },
/* harmony export */   "default": function() { return /* binding */ autobind; }
/* harmony export */ });
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(_typeof(fn)));
  } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.


  var definingProperty = false;
  return {
    configurable: true,
    get: function get() {
      // eslint-disable-next-line no-prototype-builtins
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof fn !== 'function') {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        configurable: true,
        get: function get() {
          return boundFn;
        },
        set: function set(value) {
          fn = value;
          delete this[key];
        }
      });
      definingProperty = false;
      return boundFn;
    },
    set: function set(value) {
      fn = value;
    }
  };
}
/**
 * Use boundMethod to bind all methods on the target.prototype
 */

function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys; // Use Reflect if exists

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype); // Use symbols if support is provided

    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding

    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}
function autobind() {
  if (arguments.length === 1) {
    return boundClass.apply(void 0, arguments);
  }

  return boundMethod.apply(void 0, arguments);
}

/***/ }),

/***/ 40098:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 47445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(40098),
    isIterateeCall = __webpack_require__(16612),
    toFinite = __webpack_require__(18601);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 16612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813),
    isArrayLike = __webpack_require__(98612),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 7654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNumber = __webpack_require__(81763);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 96026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(47445);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 25208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _router = __webpack_require__(62887);
var _router1 = __webpack_require__(30165);
var _useIntersection = __webpack_require__(93927);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? "replace" : "push"](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function(props, forwardedRef) {
    var _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior;
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, restProps = _objectWithoutProperties(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter"
    ]);
    children = childrenProp;
    if (legacyBehavior && typeof children === "string") {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref2.href, as = ref2.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale1 = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 73273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ StartOrdering; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Address/index.tsx + 7 modules
var Address = __webpack_require__(93154);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/helpers/addresses/AddressesContext.ts
var AddressesContext = __webpack_require__(301);
// EXTERNAL MODULE: ./src/helpers/addresses/models.ts
var models = __webpack_require__(88315);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/helpers/misc/roundToNearest.ts
var roundToNearest = __webpack_require__(24573);
// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./src/providers/MobileOrDesktopContext.ts
var MobileOrDesktopContext = __webpack_require__(95078);
;// CONCATENATED MODULE: ./src/hooks/useHeight.ts




function useHeight() {
    var ssrMobileOrDesktop = (0,react.useContext)(MobileOrDesktopContext/* default */.Z);
    var ssrHeight = ssrMobileOrDesktop === "mobile" ? 800 : 1080;
    var ref = (0,react.useState)((0,isServerSide/* default */.Z)() ? ssrHeight : window.innerHeight), height = ref[0], setHeight = ref[1];
    (0,react.useEffect)(function() {
        var handler = function handler() {
            setHeight(window.innerHeight);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return height !== null && height !== void 0 ? height : ssrHeight;
};

// EXTERNAL MODULE: ./src/hooks/useResizedImageURL.ts
var useResizedImageURL = __webpack_require__(25447);
// EXTERNAL MODULE: ./src/hooks/useShouldUseNewAddressesUI.ts
var useShouldUseNewAddressesUI = __webpack_require__(17664);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/hooks/useWidth.ts
var useWidth = __webpack_require__(9177);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var lib = __webpack_require__(25074);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/data/fragments/preferences/updateAddressFragment.ts
var updateAddressFragment = __webpack_require__(34030);
// EXTERNAL MODULE: ./src/helpers/websites/withWebsiteId.tsx
var withWebsiteId = __webpack_require__(91015);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withGraphQL.js
var withGraphQL = __webpack_require__(70791);
// EXTERNAL MODULE: ./src/components/fields/DeliveryType/index.tsx
var DeliveryType = __webpack_require__(35438);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withMessage.js
var withMessage = __webpack_require__(77543);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withMutation.js
var withMutation = __webpack_require__(68688);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/Update/index.tsx
var Update = __webpack_require__(89435);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/StoreMessage/index.tsx
var StoreMessage = __webpack_require__(13467);
// EXTERNAL MODULE: ./node_modules/autobind-decorator/lib/esm/index.js
var esm = __webpack_require__(88572);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var simple_react_form_lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/components/componentTypes/StartOrdering/Options/UpdateBasicOptions/styles.module.css
var styles_module = __webpack_require__(47105);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/StartOrdering/Options/UpdateBasicOptions/index.tsx
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation setPreferences($websiteId: ID, $storeId: ID, $placeId: ID, $deliveryType: ID) {\n    setUserPreferences(\n      websiteId: $websiteId\n      storeId: $storeId\n      placeId: $placeId\n      deliveryType: $deliveryType\n    ) {\n      _id\n      storeId\n      placeId\n      websiteId\n      deliveryType\n      deliverAt\n      time\n      channel\n      menuId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var _class, _dec, _dec1;
var _dec2 = (0,withMutation["default"])((0,graphql_tag_lib["default"])(_templateObject()));
var UpdateBasicOptions = _class = _dec2(_class = (0,withMessage/* default */.Z)(((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(UpdateBasicOptions, _Component);
    var _super = _createSuper(UpdateBasicOptions);
    function UpdateBasicOptions() {
        _classCallCheck(this, UpdateBasicOptions);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loading: null
        };
        return _this;
    }
    var _proto = UpdateBasicOptions.prototype;
    _proto.onChange = function onChange(params) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (_this.props.preferences.websiteId) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", _this.props.router.replace({
                            pathname: "/login",
                            query: {
                                nextPathname: _this.props.router.pathname
                            }
                        }));
                    case 3:
                        _this.setState({
                            loading: true
                        });
                        _ctx.next = 6;
                        return _this.props.setPreferences(_objectSpread({}, _this.props.preferences, params), {
                            refetchQueries: [
                                "getMyOrderPreferences",
                                "getUserPreferences"
                            ]
                        });
                    case 6:
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        _this.props.showMessage(_ctx.t0);
                    case 11:
                        _ctx.prev = 11;
                        _this.setState({
                            loading: false
                        });
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }))();
    };
    _proto.renderPlace = function renderPlace() {
        var deliveryType = this.props.preferences.deliveryType;
        if (deliveryType !== "delivery") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Update/* default */.Z, {
            preferences: this.props.preferences,
            onChange: this.onChange,
            autoSave: true
        });
    };
    _proto.renderStore = function renderStore() {
        if (this.state.loading) return null;
        var _props = this.props, _stores = _props.stores, stores = _stores === void 0 ? {
            items: []
        } : _stores, _preferences = _props.preferences, preferences = _preferences === void 0 ? {} : _preferences;
        var deliveryType = preferences.deliveryType;
        if (deliveryType === "delivery" || !deliveryType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMessage/* default */.Z, {
                preferences: preferences
            });
        }
        var filteredStores = stores.items.filter(function(store) {
            if (!store.address || !store.address.placeId) {
                return false;
            }
            if (deliveryType === "go" && store.acceptGo) {
                return true;
            }
            if (deliveryType === "serve" && store.acceptServe) {
                return true;
            }
            return false;
        });
        if (filteredStores.length === 1) {
            if (!this.props.preferences) return;
            if (this.state.loading) return;
            if (this.props.preferences.storeId !== filteredStores[0].value) {
                var _this = this;
                setTimeout(function() {
                    return _this.onChange({
                        storeId: filteredStores[0].value
                    });
                }, 0);
            }
            return;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
            fieldName: "storeId",
            label: "Elige un local",
            placeholder: "Selecciona un local",
            type: Select/* default */.Z,
            options: filteredStores
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(simple_react_form_lib.Form, {
                state: this.props.preferences,
                onChange: this.onChange,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                        fieldName: "deliveryType",
                        type: DeliveryType/* default */.Z,
                        light: !this.props.useBox
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: this.props.attentionClassName,
                        children: [
                            this.renderPlace(),
                            this.renderStore()
                        ]
                    })
                ]
            })
        });
    };
    return UpdateBasicOptions;
}(react.Component)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "onChange", [
    esm["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class)) || _class) || _class;
/* harmony default export */ var Options_UpdateBasicOptions = ((0,next_router.withRouter)(UpdateBasicOptions));

// EXTERNAL MODULE: ./src/components/componentTypes/StartOrdering/Options/styles.module.css
var Options_styles_module = __webpack_require__(73827);
var Options_styles_module_default = /*#__PURE__*/__webpack_require__.n(Options_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/StartOrdering/Options/index.tsx
function Options_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Options_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Options_getPrototypeOf(o1) {
    Options_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Options_getPrototypeOf(o1);
}
function Options_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Options_setPrototypeOf(subClass, superClass);
}
function Options_possibleConstructorReturn(self, call) {
    if (call && (Options_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Options_assertThisInitialized(self);
}
function Options_setPrototypeOf(o2, p1) {
    Options_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Options_setPrototypeOf(o2, p1);
}
function Options_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var Options_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Options_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Options_createSuper(Derived) {
    var hasNativeReflectConstruct = Options_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Options_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Options_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Options_possibleConstructorReturn(this, result);
    };
}
function Options_templateObject() {
    var data = Options_taggedTemplateLiteral([
        "\n    query getUserPreferences($websiteId: ID) {\n      preferences: userPreferences(websiteId: $websiteId) {\n        _id\n        websiteId\n        storeId\n        placeId\n        deliveryType\n        paymentType\n        deliverAt\n        cashAmount\n        time\n        menuId\n        ...updateAddressFragment\n      }\n      stores(websiteId: $websiteId) {\n        items {\n          _id\n          label: name\n          value: _id\n          acceptServe\n          acceptGo\n          address {\n            placeId\n          }\n        }\n      }\n    }\n    ",
        "\n  "
    ]);
    Options_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Options_class;
var Options_dec = (0,withGraphQL["default"])((0,graphql_tag_lib["default"])(Options_templateObject(), updateAddressFragment/* default */.Z), {
    loading: null
});
var Options = Options_class = (0,withWebsiteId/* default */.Z)(Options_class = Options_dec((Options_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    Options_inherits(Options, _Component);
    var _super = Options_createSuper(Options);
    function Options() {
        Options_classCallCheck(this, Options);
        return _super.apply(this, arguments);
    }
    var _proto = Options.prototype;
    _proto.render = function render() {
        var _props = this.props, preferences = _props.preferences, stores = _props.stores, attentionClassName = _props.attentionClassName, useBox = _props.useBox;
        if (!preferences) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: useBox ? (Options_styles_module_default()).box : (Options_styles_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Options_UpdateBasicOptions, {
                preferences: preferences,
                stores: stores,
                useBox: useBox,
                attentionClassName: attentionClassName
            })
        });
    };
    return Options;
}(react.Component)) || Options_class) || Options_class) || Options_class;


// EXTERNAL MODULE: ./src/components/componentTypes/StartOrdering/styles.module.css
var StartOrdering_styles_module = __webpack_require__(25547);
var StartOrdering_styles_module_default = /*#__PURE__*/__webpack_require__.n(StartOrdering_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/StartOrdering/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function StartOrdering_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function StartOrdering_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                StartOrdering_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                StartOrdering_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function StartOrdering_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function StartOrdering_templateObject() {
    var data = StartOrdering_taggedTemplateLiteral([
        "\n      query startOrderingGetDeliveryOptions($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          websiteId\n          placeId\n          deliveryType\n          storeId\n        }\n        website(websiteId: $websiteId) {\n          _id\n          deliveryTypes\n        }\n      }\n    "
    ]);
    StartOrdering_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

























var OptionsWrapper = function(param) {
    var _useBox = param.useBox, useBox = _useBox === void 0 ? false : _useBox;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = _slicedToArray((0,useState/* default */.Z)(), 2), attentionClassName = ref[0], setAttention = ref[1];
    var shouldUseNewAddressesUI = (0,useShouldUseNewAddressesUI/* default */.Z)();
    var setDeliveryType = (0,react.useContext)(AddressesContext/* default */.Z).setDeliveryType;
    var ref1 = (0,lib.useQuery)((0,graphql_tag_lib["default"])(StartOrdering_templateObject()), {
        websiteId: websiteId
    }, {
        fetchPolicy: "cache-first"
    }), preferences = ref1.preferences, website = ref1.website;
    var deliveryType1 = preferences.deliveryType, placeId = preferences.placeId, storeId = preferences.storeId;
    if (get_default()(website, "deliveryTypes", []).length === 0) return null;
    var order = function() {
        var _ref = StartOrdering_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(deliveryType1 === "go" && !storeId || deliveryType1 === "serve" && !storeId || deliveryType1 === "delivery" && !placeId)) {
                            _ctx.next = 6;
                            break;
                        }
                        setAttention("animated shake");
                        _ctx.next = 4;
                        return (0,sleep/* default */.Z)(1000);
                    case 4:
                        setAttention("animated");
                        return _ctx.abrupt("return");
                    case 6:
                        (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.addressComponentOrder);
                        router.push("/pedir");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function order() {
            return _ref.apply(this, arguments);
        };
    }();
    var button = deliveryType1 && (deliveryType1 === "serve" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/reservar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (StartOrdering_styles_module_default()).button,
                    children: "S\xf3lo reservar una mesa"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (StartOrdering_styles_module_default()).button,
                onClick: order,
                children: "Pedir y reservar una mesa"
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (StartOrdering_styles_module_default()).button,
        onClick: order,
        children: "Pedir"
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shouldUseNewAddressesUI ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Address/* AddressForm */.k, {
                    type: models/* AddressFormType.DeliveryTypes */.tv.DeliveryTypes,
                    closeModal: function() {},
                    onSelectDeliveryType: function(deliveryType) {
                        setDeliveryType(deliveryType);
                        router.push("/pedir?addressModal=true");
                    },
                    websiteId: websiteId
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (StartOrdering_styles_module_default()).button,
                    onClick: function() {
                        return router.push("/pedir?addressModal=true");
                    },
                    children: "Pedir"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                    useBox: useBox,
                    attentionClassName: attentionClassName
                }),
                button
            ]
        })
    });
};
function StartOrdering(props) {
    var backgroundImage = props.backgroundImage, title = props.title, useBox = props.useBox, _ssrImage = props.ssrImage, ssrImage = _ssrImage === void 0 ? null : _ssrImage;
    var windowWidth = (0,useWidth/* default */.ZP)();
    var windowHeight = useHeight();
    var width = (0,roundToNearest/* default */.Z)(windowWidth * 2, 200);
    if (width > 3000) width = 3000;
    if (width < 400) width = 400;
    var height = (0,roundToNearest/* default */.Z)(windowHeight * 2, 200);
    if (height > 3000) height = 3000;
    if (height < 400) height = 400;
    var url = (0,useResizedImageURL/* default */.Z)({
        fileId: backgroundImage._id,
        width: width,
        height: height
    }, {
        partial: true
    });
    var backgroundURL = url ? url : ssrImage === null || ssrImage === void 0 ? void 0 : ssrImage.resizedURL;
    if ((0,isServerSide/* default */.Z)() && !(ssrImage === null || ssrImage === void 0 ? void 0 : ssrImage.resizedURL)) {
        console.warn("Could not fetch image for StartOrdering component while doing SSR. This should be fixed for an optimized experience.");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    if (useBox) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (StartOrdering_styles_module_default()).containerBox,
            style: {
                backgroundImage: "url(".concat(backgroundURL, ")")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: (StartOrdering_styles_module_default()).boxContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StartOrdering_styles_module_default()).box,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (StartOrdering_styles_module_default()).titleBox,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsWrapper, {
                                useBox: true
                            })
                        })
                    ]
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (StartOrdering_styles_module_default()).container,
            style: {
                backgroundImage: "url(".concat(backgroundURL, ")")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (StartOrdering_styles_module_default()).overlay
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StartOrdering_styles_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (StartOrdering_styles_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsWrapper, {})
                        })
                    ]
                })
            ]
        });
    }
};


/***/ }),

/***/ 88511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_fragments_preferences_timeFieldPreferencesFragment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36375);
/* harmony import */ var _data_fragments_preferences_updateAddressFragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34030);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutDeliveryPreferences on Preference {\n    _id\n    websiteId\n    deliveryType\n    tableName\n    timeLabel\n    time\n    placeId\n    itsStoreOpenAtTime\n    dropOffType\n    itsStoreOpenAtTime\n    directions {\n      duration\n    }\n    website {\n      _id\n      name\n    }\n    address {\n      _id\n      placeId\n      address\n      addressSecondary\n      addressLine2\n      acceptsNoLine2\n      location\n      comment\n    }\n    store {\n      _id\n      name\n      schedule {\n        itsOpenNow: itsAvailableAt\n      }\n      acceptServeSchedulingOrders\n      schedulingOrdersDays\n      currentPreparationDuration\n      currentExtraDeliveryCost\n      currentDeliveryDuration\n      isOverloaded\n      address {\n        address\n        addressLine2\n      }\n    }\n    ...timeFieldPreferences\n    ...updateAddressFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject(), _data_fragments_preferences_timeFieldPreferencesFragment__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, _data_fragments_preferences_updateAddressFragment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HasWebpSupport; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var result = null;
// https://stackoverflow.com/questions/5573096/detecting-webp-support
function HasWebpSupport() {
    if (result !== null) {
        return result;
    }
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return true;
    result = false;
    var elem = document.createElement("canvas");
    if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        try {
            result = elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } catch (e) {
            result = false;
        }
    }
    // very old browser like IE 8, canvas not supported
    return result;
};


/***/ }),

/***/ 24573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RoundToNearest; }
/* harmony export */ });
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7654);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN__WEBPACK_IMPORTED_MODULE_0__);

function RoundToNearest(number, nearest) {
    if (lodash_isNaN__WEBPACK_IMPORTED_MODULE_0___default()(number)) {
        throw new Error("Number is not a number");
    }
    var times = Math.ceil(number / nearest);
    return nearest * times;
};


/***/ }),

/***/ 77712:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var sleep = function(time) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, time);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (sleep);


/***/ }),

/***/ 53023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EVENTS": function() { return /* binding */ EVENTS; },
/* harmony export */   "sendPosthogData": function() { return /* binding */ sendPosthogData; },
/* harmony export */   "sendPosthogUserInfo": function() { return /* binding */ sendPosthogUserInfo; },
/* harmony export */   "setBasicProperties": function() { return /* binding */ setBasicProperties; },
/* harmony export */   "setPosthogUserId": function() { return /* binding */ setPosthogUserId; }
/* harmony export */ });
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80251);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99893);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var setPosthogUserId = function(userId) {
    try {
        posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].identify */ .Z.identify(userId);
    } catch (e) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(e);
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var setBasicProperties = function(properties) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return;
    properties = _objectSpread({}, properties, {
        store: window.location.hostname,
        storeUrl: window.location.hostname,
        path: window.location.pathname,
        websiteVersion: "nextjs"
    });
    posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].register */ .Z.register(properties);
};
var sendPosthogUserInfo = function(userInfo) {
    try {
        posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].people.set */ .Z.people.set(userInfo);
    } catch (e) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error(e);
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var sendPosthogData = function(eventType) {
    var eventProperties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    try {
        var obj = JSON.parse(JSON.stringify(eventProperties));
        posthog_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].capture */ .Z.capture(eventType, _objectSpread({}, obj));
    } catch (e) {
        console.error({
            e: e
        });
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].exception */ .Z.exception("Posthog not loaded");
    }
};
var EVENTS = Object.freeze({
    clicked: {
        productChangeAmount: "clicked-productChangeAmount",
        addressComponentOrder: "clicked-addressComponentOrder",
        checkoutLogin: "clicked-checkoutLogin",
        upselling: "clicked-upselling",
        login: "clicked-login",
        cartRemoveProduct: "clicked-cartRemoveProduct",
        cartContinueToCheckout: "clicked-cartContinueToCheckout",
        cart: "clicked-cart",
        search: "clicked-search",
        product: "clicked-product",
        productAddToCart: "clicked-productAddToCart",
        help: "clicked-help",
        cancelOrder: "clicked-cancel-order",
        changePreferredStore: "clicked-change-preferred-store",
        omitLogin: "clicked-omit-login",
        editProduct: "clicked-edit-product",
        saveEditProduct: "clicked-save-edit-product",
        giftCheckout: "clicked-gift-checkout",
        useLocation: "clicked-use-location",
        addressSubmitButton: "clicked-address-submit-button"
    },
    selected: {
        addressOption: "selected-address-option"
    },
    error: {
        locationAccessDenied: "error-location-access-denied",
        locationUnavailable: "error-location-unavailable"
    },
    product: {
        setQuantityTo0: "update-quantity-0-product"
    },
    pageView: {
        checkout: "pageView-checkout",
        order: "pageView-order",
        home: "pageView-home",
        tracking: "pageView-tracking",
        publication: "pageView-publication"
    },
    coupon: {
        apply: "coupon-apply",
        failed: "coupon-failed"
    },
    address: {
        failed: "address-failed",
        accept: "address-accept"
    },
    pay: {
        passValidations: "pay-passValidations",
        failed: "pay-failed",
        successful: "pay-successful",
        successfulTest: "pay-successful-test"
    },
    login: "login",
    startSession: "start-session"
});


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyboardEvent(combination, callback) {
    var keysToMatch = combination.toLowerCase().split("+");
    var keys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    callbackRef.current = callback;
    var checkEvent = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysToMatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyToMatch = _step.value;
                if (!keys[keyToMatch]) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current();
    };
    var onKeyDown = function(event) {
        if (event && event.key) {
            var key = event.key.toLowerCase();
            keys[key] = true;
        }
    };
    var onKeyUp = function(event) {
        if (event && event.key) {
            checkEvent();
            var key = event.key.toLowerCase();
            delete keys[key];
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keyup", onKeyUp);
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keyup", onKeyUp);
            document.removeEventListener("keydown", onKeyDown);
        };
    });
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 25447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useResizedImageURL; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6909);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90257);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25074);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50456);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66678);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_clone__WEBPACK_IMPORTED_MODULE_1__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getResizedImage(\n        $fileId: ID\n        $scale: Float\n        $width: Float\n        $height: Float\n        $resizeMode: ID\n        $background: String\n        $format: String\n      ) {\n        image(fileId: $fileId) {\n          _id\n          resizedURL(\n            scale: $scale\n            width: $width\n            height: $height\n            resizeMode: $resizeMode\n            background: $background\n            format: $format\n          )\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function useResizedImageURL(opt) {
    var queryOpts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = lodash_clone__WEBPACK_IMPORTED_MODULE_1___default()(opt);
    if (options.format !== "jpeg" && (0,_helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) {
        options.format = "webp";
    }
    var cacheKey = "resizedImage.".concat(JSON.stringify(options));
    var cachedResult = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)() ? null : localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(cacheKey);
    var image = (0,_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_0__.useApolloQuery)(_objectSpread({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_4__["default"])(_templateObject()),
        variables: options,
        omit: !!cachedResult || !options.fileId || (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()
    }, queryOpts)).image;
    if (!options.fileId) return null;
    if (cachedResult) return cachedResult;
    if (!image) return null;
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(cacheKey, image.resizedURL);
    return image.resizedURL;
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ DEFAULT_DESKTOP_WIDTH; },
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony export DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ }),

/***/ 47105:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3O4csE5N1a9Fgx45gzz5Jv","label":"HIYKvE68DxiQ3bFtAhOgx"};

/***/ }),

/***/ 73827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2xOS0G-prTmDR4zxeHqrkS"};

/***/ }),

/***/ 25547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1AhtSgNBQZdrJ7FDzXt0F3","containerBox":"X6etWOA8Ui_qiKzF0xj5V","boxContainer":"_3uHDdvVcU9me6l9XXJ0PTh","title":"_26TWwdnPJAhejabFkROEPz appTitle","box":"_2qY3AMe0QjtXKHHNtnbMg6 shadow","titleBox":"_2NTJI2RgUSvRMsBAFD3iEm appTitle","content":"_2O5eNsUUz_CpxAOuro8Unp","label":"_1oKMjRN7GFgzOY95HzOYdk","form":"_2o94k5QKCSjvKIWP6vaTEH","overlay":"_3qNVOPc6FYocN0DfyuZV__","button":"_1OglEPY-_upwpkdnFUquCU buttonShadow"};

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(25208)


/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

}]);